import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// import { slotIsOpenAndHasProducts } from 'utils/project-definition/project-definition-data-access';

const CATEGORIES = {
  KETTLE: { id: 'kettle', icon: 'heat-generator', categoryName: 'kettle', labelId: 'kettle' },
  BOILER: { id: 'boiler', icon: 'boiler', categoryName: 'boiler', labelId: 'boiler' },
  CONTROLLER: { id: 'controllers', icon: 'controller', categoryName: 'controls', labelId: 'controllers' },
  HYDRAULICS: { id: 'hydraulics', icon: 'dial', categoryName: 'hydraulics', labelId: 'hydraulics' },
  CHIMNEY: {
    id: 'chimney',
    icon: 'chimney',
    categoryName: 'chimney',
    labelId: 'chimneys',
    singleProduct: true, // Skip list of products
  },
  HEATPUMP: { id: 'heatpumps', icon: 'heatpump', categoryName: 'pump', labelId: 'heatPumps' },
  SOLARCOLLECTOR: { id: 'solarsystem', icon: 'solarsystem', categoryName: 'solar-kit', labelId: 'solarSystems' },
};

export default class Categories extends React.Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.conditions = {
      needsKettle: () => {
        return this.productCategoryAvailable('kettle');
      },
      needsBoiler: () => {
        return this.productCategoryAvailable('boiler');
      },
      needsControls: () => {
        return this.productCategoryAvailable('controls');
      },
      needsHydraulics: () => {
        return this.productCategoryAvailable('hydraulics');
      },
      needsChimney: () => {
        return this.productCategoryAvailable('chimney') || this.productCategoryAvailable('exhaust');
      },
      needsHeatpump: () => {
        return this.productCategoryAvailable('pump');
      },
      needsSolarsystem: () => {
        return this.productCategoryAvailable('solar-kit');
      },
    };
  }

  /* Methods */

  // TODO: move to utils
  productCategoryAvailable(categoryName) {
    const { availableProducts } = this.props;
    if (!availableProducts) {
      return false;
    }
    const categoryObject = availableProducts.categoriesByName[categoryName];
    if (!categoryObject) {
      return false;
    }
    const { products } = categoryObject;
    return !!products && products.length > 0;
  }

  /* Render */

  renderCategory(categoryData, condition) {
    if (condition && !condition()) {
      return null;
    }
    const { id, icon, labelId } = categoryData;
    const clickHandlers = this.clickHandlers || {};
    this.clickHandlers = clickHandlers;
    const key = id;
    let handler = clickHandlers[key];

    if (!handler) {
      handler = (evt) => {
        const { onClickCategory } = this.props;
        if (onClickCategory) {
          return onClickCategory(evt, categoryData);
        }
        return true;
      };
      clickHandlers[key] = handler;
    }

    const translationKey = `configurator.addProductModal.categories.${labelId}`;
    return (
      <div onClick={handler} role="button" className="block product-categories__category-button">
        <div className="product-categories__category-button__icon">
          <span className={`icon icon-${icon}`} />
        </div>
        <div className="product-categories__category-button__label">
          <FormattedMessage id={translationKey} />
        </div>
      </div>
    );
  }

  render() {
    const { conditions } = this;
    return (
      <div className="product-categories__list">
        <div className="product-categories__list__button-container">
          {this.renderCategory(CATEGORIES.KETTLE, conditions.needsKettle)}
          {this.renderCategory(CATEGORIES.BOILER, conditions.needsBoiler)}
          {this.renderCategory(CATEGORIES.CONTROLLER, conditions.needsControls)}
          {this.renderCategory(CATEGORIES.HYDRAULICS, conditions.needsHydraulics)}
          {this.renderCategory(CATEGORIES.CHIMNEY, conditions.needsChimney)}
          {this.renderCategory(CATEGORIES.HEATPUMP, conditions.needsHeatpump)}
          {this.renderCategory(CATEGORIES.SOLARCOLLECTOR, conditions.needsSolarsystem)}
        </div>
      </div>
    );
  }
}

Categories.propTypes = {
  availableProducts: PropTypes.any,
  // config: PropTypes.object,
  // products: PropTypes.any,
  onClickCategory: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/add-product/categories/index.jsx